import get from 'lodash/get';
import set from 'lodash/set';
var cancelTokens = {};
export default function cancelToken(id, vault) {
    if (vault === void 0) { vault = cancelTokens; }
    return {
        isMockup: false,
        id: function () { return id; },
        set: function (foo) {
            // console.log('setting cancel ', id);
            set(vault, id, foo);
        },
        cancel: function (msg) {
            // console.log('cancelling', id);
            get(vault, id, function (msg) { })(msg);
        },
        reset: function () {
            delete vault[id];
        }
    };
}
export var mockupCancel = {
    isMockup: true,
    id: function () { return ""; },
    set: (function () { }),
    cancel: (function (msg) { }),
    reset: (function () { }),
};
